import React, { useState } from "react";
import classes from "./input.module.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

/**
 * Primary UI component for user interaction
 */
const Input = ({
  type,
  label,
  value,
  setter,
  noBorder,
  placeholder,
  disabled,
  customStyle,
  inputStyle,
  labelStyle,
  error,
  errorText,
  label2,
  leftIcon,
  inputContainer,
  inputRef,
  onkeyPress,
  ...props
}) => {
  const [passToggle, setPassToggle] = useState(false);
  let inputContainerStyleObject = Object.assign(
    {},
    error && { border: `1px solid red ` },
    leftIcon && { paddingLeft: "50px" }
  );
  return (
    <>
      <div className={`${[classes.Container, inputContainer].join(" ")}`}>
        {label && (
          <label
            htmlFor={`input${label}`}
            className={`mb-2  ${[
              classes.labelText,
              disabled && classes.disabled,
            ].join(" ")}`}
            style={{ ...labelStyle }}
          >
            {label} {label2 && label2}
          </label>
        )}
        <div
          className={`${[classes.inputPassContainer].join(" ")}`}
          style={{ ...customStyle }}
        >
          {leftIcon && <div className={classes.leftIconBox}>{leftIcon}</div>}
          <input
            value={value}
            onChange={(e) => {
              setter(e.target.value);
            }}
            disabled={disabled}
            placeholder={placeholder}
            type={passToggle == true ? "text" : type}
            id={`input${label}`}
            className={` ${[
              classes.inputBox,
              noBorder && classes.noBorder,
            ].join(" ")}`}
            style={{ ...inputContainerStyleObject, ...inputStyle }}
            ref={inputRef}
            onKeyPress={(e) =>
              ["Enter", "NumpadEnter"].includes(e.code) && onkeyPress()
            }
            {...props}
          />
          {type == "password" && passToggle == false && (
            <AiFillEyeInvisible
              className={classes.passwordIcon}
              onClick={(e) => setPassToggle(!passToggle)}
            />
          )}
          {type == "password" && passToggle && (
            <AiFillEye
              className={classes.passwordIcon}
              onClick={(e) => setPassToggle(!passToggle)}
            />
          )}
        </div>
        {error && (
          <p className={`mt-2 ${[classes.errorText].join(" ")}`}>{errorText}</p>
        )}
      </div>
    </>
  );
};
export default Input;
